import React from 'react'
import { ContextLoader } from '../../../utils/import.frames';

import Tridi from "react-tridi";
import "react-tridi/dist/index.css";
import { routesData } from '../../../data/routes.data';

import close from './../../../UI/canvas/Gallery/btn.svg'

interface Props{
    visor3DActive: boolean,
    individualSelected: string,
    currentSet: any
    currentColorsArray: any
    currentColorIndex: any
    handleChangeColors: any
    handleCloseSpin: any,
    currentColor: any,
    showLegalNote: boolean
}

interface State{
    updatedSet: any,
    zoom: number,
    closeLegalNote: boolean
}



class CarViewMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            updatedSet: [],
            zoom: 1,
            closeLegalNote: false
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.currentColor !== this.props.currentColor){
            this.setState({
                updatedSet: routesData()[0][this.props.individualSelected + " " + this.props.currentColor]
            })
        }
    }

    createColorStructure = () => {
        return(
            <div className='color-container-mobile'>
                {
                    this.props.currentColorsArray.map((color, index) => 
                        <div id='element-umbra-analytics' data-second={color.Name} data-value={this.props.individualSelected} data-type={"COLOR"} className='color-individual-container-mobile' key={index} onClick= {() => {this.props.handleChangeColors(index)}}>
                            <img id='element-umbra-analytics' data-second={color.Name} data-value={this.props.individualSelected} data-type={"COLOR"} src={color.Image}/>
                        </div>
                    )
                }
            </div>
        )
    }

    handleCloseLegal = () => {
        this.setState({
            closeLegalNote: !this.state.closeLegalNote
        })
    }

    handleZoom = (payload) => {
        this.setState({
            zoom: this.state.zoom + payload > 1.3  ? 1.3: this.state.zoom + payload < 1 ? 1: this.state.zoom + payload 
        }, () => {
            if(document.getElementById("viewerImage")){
                document.getElementById("viewerImage")!.style.transform = "scale("+String(this.state.zoom)+")"
            }
        })
    }

    render(): React.ReactNode {
        return (
            <div className={this.props.visor3DActive ? 'carview-main-mobile fade-in':'carview-main-mobile fade-out'} id={"canvas-content"}>
                {
                    this.props.visor3DActive ?
                    <Tridi 
                        element={'.tridi-basic'} 
                        dragInterval={-1} 
                        touchDragInterval={-2} 
                        location={this.state.updatedSet} 
                        format="webp" 
                        count={60} 
                        zoom="3" 
                    />: null
                }
                <div className='info-text-car-view-mobile'>Da clic en la pantalla y desliza para ver tu vehículo en 360</div>
                <div className={this.props.showLegalNote ? 'legal-edge-note-mobile fade-in':'legal-edge-note-mobile fade-out'}>
                    <div className='legal-note-edge-bar' onClick={() => {this.handleCloseLegal()}}>
                        <img className={this.state.closeLegalNote && this.props.showLegalNote ? 'rotated-symbol':'normal-symbol'} src={close}></img>
                    </div>
                    <div className={this.state.closeLegalNote && this.props.showLegalNote ? 'lega-note-edge-container-mobile-collapsed':'lega-note-edge-container-mobile'} style={{pointerEvents: "none"}}>
                        <div className={this.state.closeLegalNote && this.props.showLegalNote ? 'edge-legal-title-mobile fade-out':'edge-legal-title-mobile fade-in'} style={{pointerEvents: "none"}}>Imagen de referencia</div>
                        <div className={this.state.closeLegalNote && this.props.showLegalNote ? 'edge-legal-text-mobile fade-out':'edge-legal-text-mobile fade-in'} style={{pointerEvents: "none"}}>Algunas características pueden variar con respecto al vehículo comercializado en Colombia. No incluye barras de techo y los rines varían con respecto al vehículo comercializado.</div>
                    </div>
                </div>
                <div className='car-view-color-name-mobile'>{this.props.currentColor}</div>
                <div className='car-view-wrapper-mobile'>
                {
                    this.props.currentColorsArray.length > 0 ?
                    this.createColorStructure():null
                }
                <div className='bike-view-zoom-mobile'>
                        <div className='plus' onClick={() => {this.handleZoom(+0.1)}}>
                            +
                        </div>
                        <div className='minus' onClick={() => {this.handleZoom(-0.1)}}>
                            -
                        </div>
                </div>
                </div>
            </div>
        )
    }
}

export default CarViewMobile